import React, { FC } from 'react';

import { format } from '@r1-frontend/ui-react/components/costs';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import * as ST from './styled';

interface IProps {
    onClick: () => void,
    isActive: boolean,
    months: number,
    desc: string,
    price: number | string,
    fullPrice?: number,
}

const YandexTrial: FC<IProps> = ({ months, price, isActive, onClick, fullPrice = 0 }) => {
    const monthText = `${months} ${pluralize(months, monthPluralize)}`;

    return (
        <ST.Wrapper isActive={isActive} onClick={onClick}>
            <ST.Title>На {monthText}</ST.Title>
            <ST.Price>Абонентская плата&nbsp;&mdash; {format(price, { monthly: true })} в&nbsp;течение {monthText}, далее {format(fullPrice, { monthly: true })}</ST.Price>
            <ST.Description>
                Смотрите всё что есть в Яндекс Плюс со скидкой в течении {monthText}
            </ST.Description>
        </ST.Wrapper>
    );
};

export default YandexTrial;
